<div class="header-auction-detail-cntr">

    <div class="left">

        <i class="pi pi-arrow-left" style="font-size: 2rem; color: #1F5598;" (click)="closeDialog()"></i>

    </div>
    <div class="center">

        <h2 style="margin: 0;">{{conf.data.configuration.title}}</h2>

    </div>

</div>
